import React from 'react';

// TODO use this component for all delimiters
const Divider = () => <span>&nbsp;•&nbsp;</span>;

export default Divider;
